import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import Header from "@/components/common/header/DefaultHeader";
import { TailSpin } from "react-loader-spinner";
import {unsubscribeUser }  from "@/api/unsubscribeEmail";
import "./Unsubscribe.css"
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const Unsubscribe = () => {
  const [email, setEmail] = useState("");
  const [preferences, setPreferences] = useState({
    promotional: false,
    watchedProperties: false,
  });
  const [emailError, setEmailError] = useState("");
  const [invalidemail, setInvalidEmail] = useState("");
  const [checkboxError, setCheckboxError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setPreferences((prev) => ({ ...prev, [name]: checked }));
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");
    setCheckboxError("");

    let valid = true;
    if (!email.trim()) {
      setEmailError("Please enter email address");
      valid = false;
    }
    if (!preferences.promotional && !preferences.watchedProperties) {
      setCheckboxError("Please select at least one mailing list");
      valid = false;
    }
    if (!valid) return;

    // determine mode
    let subscriptionMode = "";
    if (preferences.promotional && preferences.watchedProperties) {
      subscriptionMode = "ALL";
    } else if (preferences.promotional) {
      subscriptionMode = "PROMOTION";
    } else {
      subscriptionMode = "NOTIFICATION";
    }

    try {
      const { status, message } = await unsubscribeUser(email, subscriptionMode);
      if (status === "N") {
        // API says invalid
        setInvalidEmail("Incorrect email! Please enter the email id registered with Hubzu.");
        return;
      }
      // success
      setSubmitted(true);
    } catch {
      setInvalidEmail("Something went wrong. Please try again.");
    }
  };


  useEffect(() => {
    if (submitted && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (submitted && countdown === 0) {
      navigate("/");
    }
  }, [submitted, countdown, navigate]);

  return (
    <div>
         <Header />
    <div
      className="container"
      style={{
        maxWidth: "1024px",
        margin: "100px auto 20px auto",
        backgroundColor: "#fff",
        padding: "40px",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      {!submitted ? (
        <>
          <h2 className="mb-4 text-start">Unsubscribe</h2>
          <p className="mb-4 text-start">
            We're sorry to see you go but happy to accommodate your request.
            Please choose the Hubzu® mailing lists you'd like to be removed
            from:
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-check mb-3 text-start">
              <input
                type="checkbox"
                className="form-check-input"
                id="promotional"
                name="promotional"
                checked={preferences.promotional}
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label" htmlFor="promotional">
                Promotional &amp; Marketing
              </label>
            </div>

            <div className="form-check mb-4 text-start">
              <input
                type="checkbox"
                className="form-check-input"
                id="watchedProperties"
                name="watchedProperties"
                checked={preferences.watchedProperties}
                onChange={handleCheckboxChange}
              />
              <label className="form-check-label" htmlFor="watchedProperties">
                Watched Properties &amp; Saved Searches
              </label>
            </div>
            {checkboxError && <div className="text-danger mb-3 text-start">{checkboxError}</div>}   
      <div className="mb-4 text-start">
        <div className="d-flex align-items-center gap-3">
          <label
          htmlFor="email"
          className="form-label mb-0"
          style={{ minWidth: "185px" }}
          >
          Enter your email address
          </label>
          <input
          type="email"
          className="form-control"
          id="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ height: "55px", borderRadius: "8px", width: "75%" }}
          />
        </div>
    {emailError && (
    <div className="text-danger mt-2" style={{ marginLeft: "202px" }}>
      {emailError}
    </div>
    )}
  </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              style={{
                height: "60px",
                fontSize: "16px",
                borderRadius: "10px",
                backgroundColor: "#1e88e5",
                borderColor: "#1e88e5",
              }}
            >
              UNSUBSCRIBE
            </button>
             {invalidemail && <div className=" emailerror text-danger text-start">{invalidemail}</div>}
          </form>
        </>
      ) : (
        <div className="text-center">
          <h3 className="mb-4 text-uppercase">UNSUBSCRIBE CONFIRMATION</h3>
          <p>
            You've successfully unsubscribed. Please allow up to thirty days to
            stop receiving these emails.
          </p>
          <p className="customermail">
            If you change your mind, just send an email to{" "}
            <a href="mailto:customercare@hubzu.com">
              customercare@hubzu.com
            </a>{" "}
            and let us know.
          </p>

          <div className="mt-5">
            <p>
              <strong>TAKING YOU TO</strong>
              <br />
              HUBZU HOME PAGE IN
            </p>
            <h1 style={{ fontSize: "48px" }}>{countdown}</h1>
            <TailSpin height="40" width="40" color="#1e88e5" />
          </div>
        </div>
      )}
    </div>
      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
       <div className="container-fluid px-0">
        {/* <Footer /> */}
        <OtherLinkFooter />
        <NewFooter  />
      </div>
    </div>
  );
};

export default Unsubscribe;
